// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"d2d161e8","478":"4236efe0","518":"37f1cc86","816":"e3a68d5f","947":"7fd815aa"}[chunkId] + ".chunk.js";
};